export const computeVisitedSteps = (reachableSteps, highestReachedIndex, isPreview)=>{
    if (isPreview) return reachableSteps;
    return reachableSteps.slice(0, highestReachedIndex + 1);
};
